import { nextPrev, setCurrentStep, getConsent, setUploadDocumentInstructionVisible } from "../utils/StepService";
import { getAssetUrl, setLoading } from "../utils";
import { getSessionData, getShadowRoot, setUploadDocumentConsent } from "../utils/store";
import { isMobile } from "../utils";

class UploadDocumentSelection {
  getImageUrl(path) {
    return getAssetUrl(`Images/${path}`);
  }

  getThumbUrl(path) {
    return getAssetUrl(`Images/thumbs/${path}`);
  }

  render() {
    const shadow = getShadowRoot();
    const modalBox = shadow.querySelector("#identity-modal__box");
    let sessionData = getSessionData();
    let isFaceCaptureOption = sessionData.nextVerificationStep === 'FaceCaptureOptions';

    if (modalBox.querySelector("#uploadDocumentSelectionContent")) return;

    modalBox.insertAdjacentHTML(
      "beforeend",
      `
      <div class="form-content upload-document-selection"
           id="uploadDocumentSelectionContent"
           data-form-tab>

        <div class="upload-card">

          <h3 class="upload-title">
            Upload photo of your Driving License
          </h3>

          <!-- SLIDER -->
     <div class="slider-wrapper">
    <div id="idSlider" class="slider-track">

    <div class="slide">
      <a href="${this.getImageUrl("avoid-reflections.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("avoid-reflections.jpg")}" alt="Avoid Reflections" loading="eager" decoding="async" fetchpriority="high" width="640" height="215"/>
      </a>
      <div class="slide-caption">Avoid Reflections</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("correct-angle.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("correct-angle.jpg")}" alt="Correct Angle" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Keep Correct Angle</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("correct-margins.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("correct-margins.jpg")}" alt="Correct Margins" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Correct Margins</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("extraneous-objects.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("extraneous-objects.jpg")}" alt="Extraneous Objects" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Avoid Extraneous Objects</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("focus-sharpness.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("focus-sharpness.jpg")}" alt="Focus & Sharpness" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Maintain Focus & Sharpness</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("image-quality.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("image-quality.jpg")}" alt="Image Quality" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">High Image Quality</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("margins-too-big.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("margins-too-big.jpg")}" alt="Margins Too Big" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Avoid Excessive Margins</div>
    </div>

    <div class="slide">
      <a href="${this.getImageUrl("provide-good-lighting.jpg")}" target="_blank">
        <img src="${this.getThumbUrl("provide-good-lighting.jpg")}" alt="Good Lighting" loading="lazy" decoding="async" fetchpriority="low" width="640" height="215"/>
      </a>
      <div class="slide-caption">Provide Good Lighting</div>
    </div>

  </div>
</div>

          <!-- VALID LIST -->
          <ul class="valid-list">
            <li><span class="icon valid"></span>Entire document is visible</li>
            <li><span class="icon valid"></span>Well-lit, no glare or shadow</li>
            <li><span class="icon valid"></span>Not blurry, text is readable</li>
            <li><span class="icon valid"></span>Both front & back if required</li>
          </ul>

          <!-- INVALID LIST -->
          <ul class="invalid-list">
            <li><span class="icon invalid"></span>Cropped edges</li>
            <li><span class="icon invalid"></span>Blurry or dark photo</li>
            <li><span class="icon invalid"></span>Covered by fingers or reflection</li>
          </ul>

          <div class="verification-info">
            The ID verification process takes approximately 20 seconds.
          </div>

          <div class="button-wrapper">
            <button type="button"
              class="continue-btn"
              id="btnUsePhone">
              CONTINUE
            </button>
          </div>

        </div>
      </div>
      `
    );

    this.injectStyles();
    this.startSlider();
    this.bindEvents();
  }

  injectStyles() {
    const shadow = getShadowRoot();
    if (shadow.querySelector("#uploadDocStyles")) return;

    const style = document.createElement("style");
    style.id = "uploadDocStyles";
    style.textContent = `
      .upload-card {
        max-width:520px;
        margin:10px auto;
        background:#071b2d;
        border-radius:16px;
        padding:5px 5px;
        color:#d6e2f0;
        font-family:Arial, sans-serif;
        box-shadow:0 15px 40px rgba(0,0,0,0.45);
      }

      .upload-title {
        text-align:center;
        font-size:20px;
        font-weight:600;
        margin-bottom:25px;
        color:#ffffff;
      }

      .slider-wrapper {
        width:100%;
        height:140px;
        overflow:hidden;
        border-radius:12px;
        margin-bottom:25px;
      }

      .slider-track {
        display:flex;
        height:100%;
        transition:transform 0.8s ease;
      }

      .slider-track img {
        min-width:100%;
        height:100%;
        object-fit:scale-down;
        display:block;
      }
        .slide {
  min-width:100%;
  height:100%;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  text-align:center;
}

.slide img {
  width:100%;
  height:100px;
  object-fit:contain;
   cursor: pointer;
}

.slide-caption {
  margin-top:6px;
  font-size:17px;
  font-weight:500;
  color:#cbd5e1;
}

      .valid-list,
      .invalid-list {
        list-style:none;
        padding:0;
        margin:0 0 20px 0;
        font-size:14px;
        line-height:1.9;
        position: relative;
      }

      .valid-list li,
      .invalid-list li {
        display:flex;
        align-items:center;
        gap:10px;
      }

      .icon {
        font-weight:bold;
        font-size:15px;
      }

      .valid-list .icon.valid::before {
          content: "✓";
          font-weight: bold;
          margin-right: 5px;
          margin-left: 10px;
          color:#22C55E;
        }

        .invalid-list .icon.invalid::before {
          content: "✕";
          font-weight: bold;
          margin-right: 5px;
          margin-left: 10px;
          color:#ef4444 !important;
        }

      .verification-info {
        text-align:center;
        font-size:15px;
        opacity:1;
        margin:10px 0 10px;
      }

      .button-wrapper {
        text-align:center;
      }

      .continue-btn {
        width:100%;
        height:48px;
        border:none;
        border-radius:8px;
        background:#1E73E8;
        color:#ffffff;
        font-size:14px;
        font-weight:600;
        letter-spacing:0.5px;
        cursor:pointer;
        transition:all 0.2s ease;
      }

      .continue-btn:hover {
        background:#1667d6;
      }
    `;

    shadow.appendChild(style);
  }

  startSlider() {
    const shadow = getShadowRoot();
    const slider = shadow.querySelector("#idSlider");
    if (!slider) return;

    let index = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const firstClone = slides[0].cloneNode(true);
    slider.appendChild(firstClone);

    setInterval(() => {
      index++;
   slider.style.transform = `translateX(-${index * 100}%)`;
      if (index === totalSlides) {
        setTimeout(() => {
          slider.style.transition = "none";
          slider.style.transform = "translateX(0%)";
          index = 0;
          setTimeout(() => {
            slider.style.transition = "transform 0.8s ease";
          }, 50);
        }, 800);
      }
    }, 4000);
  }

  bindEvents() {
    const shadow = getShadowRoot();
    const usePhoneBtn = shadow.querySelector("#btnUsePhone");
    if (!usePhoneBtn) return;

    usePhoneBtn.addEventListener("click", async () => {
        await setUploadDocumentInstructionVisible(false);

      setLoading(true);
      if (isMobile()) {
        let data = await getConsent("IDPhotoUpload");
        setUploadDocumentConsent(data);
        await nextPrev(1);
      } else {
        await setCurrentStep("mobileVerificationQR");
        await nextPrev(1);
      }
      setLoading(false);
    });
  }
  
}

export default UploadDocumentSelection;
